import type { CmsApiBlock } from '#/modules/cms/api/types/CmsApiBlock';
import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';

type Props = {
  content: CmsApiDocument;
};

export function getContentHasBodyHeader({ content }: Props) {
  const [firstBlock]: (CmsApiBlock | undefined)[] = content.contentBlocks;

  const firstBlockSkipsTitle =
    content.contentBlocks &&
    content.contentBlocks.length > 0 &&
    (['CTA_HERO', 'DONATE', 'SUPPORT_CONTACT_FORM'].includes(firstBlock.type) ||
      (firstBlock.type === 'SPLIT_CONTENT' &&
        firstBlock.data.appearance === 'FULL_WIDTH'));

  if (firstBlockSkipsTitle || content.heroSearch) return false;

  return content.showTitle;
}
